import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '品牌介紹', href: '/about' },
  { label: '合作通路', href: '/stores' },
  { label: '常見問答', href: '/faq' },
  { label: '閱讀推薦', href: '/blog' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="section-container py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/1b4ec386-92cf-4cf4-b2ad-72663a227370_compressed_logo.webp"
                alt="未境原創 VIJING"
                className="h-8 w-auto"
              />
              <span className="text-lg font-heading font-semibold tracking-wide text-white">未境原創 VIJING</span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed mb-3 max-w-sm">
              未境原創以愛情小說為主要出版方向。
            </p>
            <p className="text-xs text-background-300 leading-relaxed mb-2 max-w-sm">
              本品牌委託崧博出版經銷，官方網站由崧博出版製作。
            </p>
            <p className="text-xs text-background-400 leading-relaxed mb-6 max-w-sm">
              個別作品內容與作者觀點，不代表未境原創或崧博出版的官方立場。
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <a
                href="https://sonbook.net"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors cursor-pointer group"
              >
                前往崧博出版
                <i className="ri-arrow-right-up-line text-xs group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <span className="text-background-500">·</span>
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors cursor-pointer group"
              >
                前往書籍資料庫
                <i className="ri-arrow-right-up-line text-xs group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-label font-medium text-white mb-4">網站導覽</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200 hover:text-white transition-colors cursor-pointer">
                  首頁
                </Link>
              </li>
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-200 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-label font-medium text-white mb-4">相關站點</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a
                  href="https://sonbook.net"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-background-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-external-link-line text-xs"></i>
                  崧博出版主站
                </a>
              </li>
              <li>
                <a
                  href="https://catalog.sonbook.net/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-background-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-external-link-line text-xs"></i>
                  崧博書籍資料庫
                </a>
              </li>
              <li>
                <a
                  href="https://www.books.com.tw/web/sys_puballb/books/?pubid=lianhe140"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-background-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-external-link-line text-xs"></i>
                  博客來品牌書目
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-primary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            &copy; {new Date().getFullYear()} 未境原創. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/faq" className="text-xs text-background-300 hover:text-background-100 transition-colors cursor-pointer">
              常見問答
            </Link>
            <Link to="/stores" className="text-xs text-background-300 hover:text-background-100 transition-colors cursor-pointer">
              合作通路
            </Link>
            <a
              href="https://sonbook.net"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-xs text-background-300 hover:text-background-100 transition-colors"
            >
              崧博出版
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
